import { styles } from "@repo/helpers";

import style from "./style.module.scss";
import { ButtonColor, ButtonProps, ButtonSize, ButtonTypes } from "./types";

export function Button(props: ButtonProps) {
	/**
	 * Concatenate all the class names based on the button
	 * type and the class name provided
	 */
	function getClassName() {
		const { className, disabled, types, size, fullWidth, color } = props;

		const classes = [className, style.btn];
		classes.push(disabled && style.disabled);
		classes.push(fullWidth && style.fullWidth);

		for (const type of types ?? []) {
			switch (type) {
				case ButtonTypes.Primary:
					classes.push(style.btnPrimary);
					break;
				case ButtonTypes.Danger:
					classes.push(style.btnDanger);
					break;
				case ButtonTypes.Green:
					classes.push(style.btnGreen);
					break;
				case ButtonTypes.Circle:
					classes.push(style.btnCircle);
					break;
				case ButtonTypes.Text:
					classes.push(style.btnText);
					break;
				case ButtonTypes.Warning:
					classes.push(style.btnDarkYellow);
					break;
				case ButtonTypes.Outline:
					classes.push(style.outline);
					break;
			}
		}

		switch (color) {
			case ButtonColor.LightBlue:
				classes.push(style.btnLightBlue);
				break;
			case ButtonColor.DarkGreen:
				classes.push(style.btnDarkGreen);
				break;
			case ButtonColor.Green:
				classes.push(style.btnGreen);
				break;
			case ButtonColor.DarkYellow:
				classes.push(style.btnDarkYellow);
				break;
			case ButtonColor.DarkBlue:
				classes.push(style.btnPrimary);
				break;
		}

		switch (size) {
			case ButtonSize.large:
				classes.push(style.btnLg);
				break;
			case ButtonSize.medium:
				classes.push(style.btnMd);
				break;
			case ButtonSize.small:
				classes.push(style.btnXs);
				break;
		}

		return styles(...classes);
	}

	const { title, type = "button", disabled, onClick, tabIndex, id, children } = props;
	return (
		<button
			className={getClassName()}
			onClick={onClick}
			title={title}
			type={type}
			disabled={disabled}
			tabIndex={tabIndex}
			id={id}
		>
			{children}
		</button>
	);
}

export * from "./types";
